<footer class="footer">
  <div class="kt-container-fixed">
    <div class="flex flex-col md:flex-row justify-center md:justify-between items-center gap-3 py-5">
      <div class="flex order-2 md:order-1 gap-2 font-normal text-sm">
        <span class="text-muted-foreground">2026©</span>
        <span class="text-secondary-foreground">Frida</span>
      </div>
      <nav class="flex order-1 md:order-2 gap-4 font-normal text-sm text-secondary-foreground">
      </nav>
    </div>
  </div>
</footer>